<template>
  
  <div class="w-table-wrap" >
    <table class="w-table" color="light" >
      <thead>
        <tr>
          <th class="w-table__header  text-left" width="1%">No</th>
          <th class="w-table__header  text-left">Baka</th>
          <th class="w-table__header  text-left">Kod</th>
          <th class="w-table__header  text-left"  width="1%">Tindakan</th>
        </tr>
      </thead>

      <tbody>
        <template v-if="datas.length == 0">
          <tr class="w-table__row" >
            <td class="w-table__cell text-left" colspan="20"> Tiada Data.</td>
          </tr>
        </template>
        <template v-for="(dt, ind) in datas">
          <tr class="w-table__row" >
            <td class="w-table__cell text-left" >{{ind+1}}</td>
            <td class="w-table__cell text-left" >{{dt.lkp_baka.nama}}</td>
            <td class="w-table__cell text-left" >{{dt.kode}}</td>
            <td class="w-table__cell text-left" >
              <inertia-link :href="$route('baka.show',dt.id)" class="w-button black  info-dark1--bg size--md be fs-2"> 
                <w-icon xs class="mr2">fal fa-eye</w-icon>  Papar
              </inertia-link>
            </td>
            
          </tr>
        </template>
      </tbody>
    </table>
  </div>


</template>

<script>
export default {
  name: "Pemilik",
  props:{
    data: [Array, Object],
  },
  data() {
    return {
      form : {},
      datas : [],
      
    }
  },
  methods:{
    getData(){
      this.$zcomm.get(this.api_service + 'ternakan/induk_jantan/'+this.data.id, {}).then(res => {
        this.datas = res
      })
    },
    
  },
      
  mounted() {
    this.getData()
    
  }
}
      

</script>  
